export enum Network {
  DencunDevnet12 = 'dencun-devnet-12',
  EthDADevnet = 'ethda-devnet',
}
